import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EstadoPropuesta } from '../../../../interfaces/propuesta';
import { PropuestasService } from '../../../../providers/propuestas.service';
import { ProspectoService } from '../../../../providers/prospecto.service';

@Component({
  selector: 'app-eliminar-estado-propuesta-dialog',
  templateUrl: './eliminar-estado-propuesta-dialog.component.html',
  styleUrls: ['./eliminar-estado-propuesta-dialog.component.scss']
})
export class EliminarEstadoPropuestaDialog implements OnInit {
  error: string = '';
  cargando: boolean = true;
  razonSocial: string = null;

  estado_propuesta: any;

  constructor(
    public dialogEliminar: MatDialogRef<EliminarEstadoPropuestaDialog>,
    private propuestaService: PropuestasService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.propuestaService.getEstadoPropuesta(this.data.IdEstado).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.estado_propuesta) {
          // console.log(this.data);
          let estado_propuesta = respuesta.estado_propuesta;
          this.estado_propuesta = new EstadoPropuesta(
            estado_propuesta.id,
            estado_propuesta.descripcion,
            estado_propuesta.orden
          );
        }
        this.cargando = false;

      }, () => {
        this.cargando = false;
      }
    );
  }

  onCancelar(): void {
    this.dialogEliminar.close();
  }

  onEliminar(): void {
    this.error = '';

    try { // cacheo de errores antes de llamar al servidor
      this.cargando = true;
      this.propuestaService.eliminarEstadoPropuesta(this.data.IdEstado).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            this.dialogEliminar.close(respuesta);
          } else {
            this.error = respuesta.mensaje;
          }

          this.cargando = false;
        },
        error => {
          this.cargando = false;
          this.error = error;
        });
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }
  }
}